module.exports = __webpack_public_path__ + "static/media/menu-overlay-projects.9d816e38.jpg";